import React, { useState, ChangeEvent, useEffect } from "react";
import Image from "next/image";
import { NextSeo } from "next-seo";

import { USER_VALIDATIONS } from "constants/validationRules";
import Navbar from "components/Landing/Navbar";
import { useAuth } from "context/AuthContext";

import { useRouter } from "next/router";
import { BASE_URL } from "constants/redirects";
import { RAY_EMAIL } from "constants/contacts";

function Contact() {
  const { user } = useAuth();
  const router = useRouter();
  const [name, setName] = useState("");
  const [email, setEmail] = useState(user?.email || "");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (user?.email) {
      setEmail(user.email);
    }
  }, [user?.email]);

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) =>
    setName(e.target.value);
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) =>
    setEmail(e.target.value);
  const handleMessageChange = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setMessage(e.target.value);

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    fetch("/api/sendgrid", {
      body: JSON.stringify({
        to: RAY_EMAIL,
        from: {
          email: RAY_EMAIL,
          name: email,
        },
        subject: `New contact submission from ${email || name}`,
        text: `Email: ${email} /n Message: ${message}`,
        html: `<div>Email: ${email}</div> <div>Message: ${message}</div>`,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    }).then(() => {
      router.push("/contact#thanks");
    });
  };

  const hasChanges = email && message;

  const showThanksMessage = router?.asPath && router.asPath.includes("#thanks");

  return (
    <>
      <NextSeo title="Contact" description="Contact Act Now Button" />

      <main className="relative min-h-screen w-screen overflow-x-hidden">
        <div className="relative isolate mt-[80px] flex w-screen flex-col items-center justify-center overflow-hidden px-10 py-12">
          <h1 className="sr-only">CONTACT</h1>
          {showThanksMessage ? (
            <div className="mt-2 text-lg leading-8 text-gray-600">
              Thanks for your message!
            </div>
          ) : (
            <form
              name="actnowbuttoncontact"
              method="post"
              action="#"
              onSubmit={handleContactSubmit}
              className="flex w-full max-w-2xl flex-col justify-center space-y-6"
            >
              <input
                type="hidden"
                name="form-name"
                value="actnowbuttoncontact"
              />

              <div>
                <label
                  htmlFor="actnowbuttonContactName"
                  className="text-sm font-semibold leading-6 text-gray-900"
                >
                  Name:
                </label>
                <div className="mt-2.5">
                  <input
                    maxLength={USER_VALIDATIONS.contactNameMaxLength}
                    className="w-full appearance-none rounded-md border border-gray-300 px-3 py-2 text-sm placeholder-gray-400 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-emerald-500 sm:text-base"
                    type="text"
                    name="actnowbuttonContactName"
                    id="actnowbuttonContactName"
                    autoComplete="name"
                    value={name}
                    onChange={handleNameChange}
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="actnowbuttonContactEmail"
                  className=" text-sm font-semibold leading-6 text-gray-900"
                >
                  Email:
                </label>
                <div className="mt-2.5">
                  <input
                    maxLength={USER_VALIDATIONS.contactEmailMaxLength}
                    className="w-full appearance-none rounded-md border border-gray-300 px-3 py-2 text-sm placeholder-gray-400 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-emerald-500 sm:text-base"
                    type="email"
                    name="actnowbuttonContactEmail"
                    id="actnowbuttonContactEmail"
                    autoComplete="email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="actnowbuttonContactMessage"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Message:
                </label>
                <div className="mt-2.5">
                  <textarea
                    maxLength={USER_VALIDATIONS.contactMessageMaxLength}
                    className="block w-full rounded-md border-gray-300 text-sm shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-base"
                    name="actnowbuttonContactMessage"
                    id="actnowbuttonContactMessage"
                    value={message}
                    onChange={handleMessageChange}
                    required
                  ></textarea>
                </div>
              </div>

              <button
                disabled={!hasChanges}
                type="submit"
                className="mt-8 flex w-auto flex-wrap content-center items-center justify-center rounded-full border border-transparent bg-emerald-600 py-2 px-10 text-sm  font-medium text-white shadow-sm hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-emerald-600 disabled:opacity-70 sm:text-base"
              >
                Send
              </button>
            </form>
          )}
        </div>
        <Navbar />
      </main>
    </>
  );
}

export default Contact;
